import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, setStep, setQuoteData } from '../../../../actions/salesActions';
import KPSelectableList from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableList/KPSelectableList'
import { ISelectableListItem } from '../../../../interfaces/KPSelectableList/KPSelectableListInterfaces';
import './OwnerTenant.css';
import { postToController } from '../../../../actions/apiActions';
import { BUILDING_OCCUPANT_OWNER_ID, BUILDING_OCCUPANT_STORAGE_ID, BUILDING_OCCUPANT_TENNANT_ID } from '../../../../constants/constants';
import Profile from '../../../Profile/Profile';

class OwnerTenant extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        
        this.state = {
            items: [],
            selectedOption: this.props.sales.buildingLiving ?? "",
            submitted: false,
            nextDisabled: false
        };

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleItemSelect = this.handleItemSelect.bind(this);
        this.getListDataSet = this.getListDataSet.bind(this);
    }

    async componentWillMount() {
        await this.getListDataSet();
        this.checkSubmit();
    }

    checkSubmit() {
        this.setState({ nextDisabled: this.state.selectedOption.length === 0 });
    }

    async getListDataSet() {
        let isOwner = this.props.sales.buildingLiving.toString().includes(BUILDING_OCCUPANT_OWNER_ID);
        let isStorage = this.props.sales.buildingLiving.toString().includes(BUILDING_OCCUPANT_STORAGE_ID);
        let isTenant = this.props.sales.buildingLiving.toString().includes(BUILDING_OCCUPANT_TENNANT_ID);

        let dataSet: ISelectableListItem[] = [];
        await postToController(this.props.dispatch, 'GetBuildingOccupants', JSON.stringify({ Parameter: this.props.profile.countryId })).then(async (response) => {
            response.forEach((item, index) => {
                switch (item.id) {
                    case BUILDING_OCCUPANT_OWNER_ID:
                        dataSet.push({
                            id: item.id,
                            value: item.id,
                            label: item.description,
                            selected: isOwner,
                            required: false,
                            disabled: false,
                            handleSelect: null,
                            selectOnLeft: false,
                            className: ""
                        } as ISelectableListItem);
                        break;
                    case BUILDING_OCCUPANT_TENNANT_ID:
                        dataSet.push({
                            id: item.id,
                            value: item.id,
                            label: item.description,
                            selected: isTenant,
                            required: false,
                            disabled: false,
                            handleSelect: null,
                            selectOnLeft: false,
                            className: ""
                        } as ISelectableListItem);
                        break;
                    case BUILDING_OCCUPANT_STORAGE_ID:
                        dataSet.push({
                            id: item.id,
                            value: item.id,
                            label: item.description,
                            selected: isStorage,
                            required: false,
                            disabled: false,
                            handleSelect: null,
                            selectOnLeft: false,
                            className: ""
                        } as ISelectableListItem);
                        break;
                    default:
                        break;
                }
            });
        });
       
        await this.setState({ items: dataSet });
    }

    handleItemSelect(id: string, selected: boolean) {
        this.setState({ selectedOption: id }, () => this.checkSubmit());
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            let isOwner = (this.state.selectedOption === BUILDING_OCCUPANT_OWNER_ID);
            let isStorage = (this.state.selectedOption === BUILDING_OCCUPANT_STORAGE_ID);

            this.props.dispatchAction(
                setQuoteData({
                    buildingLiving: this.state.selectedOption,
                    buildingOwner: isOwner,
                    buildingStorage: isStorage
                })
            );

            if (isOwner) {
                this.props.dispatchAction(handleNextStep()); //Financed question substep
            }
            else {
                //If storage then skip to step 6 (building age), else skip to step 5 (building use)
                let nextStep = !isStorage ? 5 : 6;
                this.props.dispatchAction(setStep(nextStep, 1));

                this.props.dispatchAction(
                    setQuoteData({
                        financed: false,
                        financeHouse: "",
                        financeHouseId: -1,
                    })
                );
            }
        }
    }

    public render() {
        return (
            <div className="container">
                <div className="mt-4 text-center">
                    Who’ll be living in the home?
                </div>
                {this.state.items.length > 0 &&
                    <div className="row mt-4">
                        <div className="col-md-6 offset-md-3" style={{ textAlign: "left" }}>
                            <KPSelectableList
                                items={this.state.items}
                                handleSelect={this.handleItemSelect}
                                radioGroup={true}
                                autosize={true}
                            />
                        </div>
                    </div>
                }
                <div className="row mt-4">
                    <div className="col-12 justify-content-center mt-4">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OwnerTenant);